import CurrencyTable from 'components/features/currency-table';
import HomeLayout from 'layouts/home-layout';
import { useTranslation } from 'react-i18next';

function CurrencyRecords() {
  const { t } = useTranslation();

  return (
    <HomeLayout title={t('general.currency')}>
      <CurrencyTable />
    </HomeLayout>
  );
}

export default CurrencyRecords;
